(() => {
  const root = document.querySelector('[data-jp-sale]');
  if (!root || window.Shopify?.designMode) return;
  const allowed = () => typeof window.gtag === 'function' && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const emit = (name, slot, variantId) => {
    if (!allowed()) return false;
    const payload = {send_to:'G-PV9P5P9K11',promotion_id:'jp-special-sale-2610',promotion_name:'HiDock 特別セール',creative_slot:slot};
    if (variantId) payload.items = [{item_id:String(variantId)}];
    if (root.dataset.jpSalePreview === 'true') payload.debug_mode = true;
    window.gtag('event', name, payload);
    return true;
  };
  let seen = false, sent = false, attempts = 0;
  const view = () => { if (seen && !sent) sent = emit('view_promotion', 'sale_hero'); };
  const observer = new IntersectionObserver(entries => {
    if (entries.some(e => e.isIntersecting)) { seen = true; view(); observer.disconnect(); }
  }, {threshold:0.25});
  observer.observe(root.querySelector('.hero-copy'));
  const timer = setInterval(() => { view(); if (sent || ++attempts >= 60) clearInterval(timer); }, 500);
  document.addEventListener('visitorConsentCollected', view);
  root.addEventListener('submit', event => {
    const form = event.target.closest('.jp-sale-form');
    if (form) emit('select_promotion', form.closest('.hero-offer') ? 'hero_add' : form.closest('article')?.id || 'product_card', form.querySelector('[name="id"]')?.value);
  }, true);
  root.addEventListener('click', event => {
    const link = event.target.closest('a');
    if (!link) return;
    const article = link.closest('article');
    if (article || ['#h1','#h1e','#mini','#lite','#offers'].includes(link.getAttribute('href'))) {
      emit('select_promotion', article?.id || link.closest('section')?.id || 'sale_navigation', article?.querySelector('[name="id"]')?.value);
    }
  });
})();
